import o from"react";const r=o.Fragment;export{r as Tab};
